"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(attr, value) {
  var element = document.createElement('div');

  if (attr in element.style) {
    element.style[attr] = value;
    return element.style[attr] === value;
  } else {
    return false;
  }
};

exports["default"] = _default;